import { MessageDialogData } from '../interfaces/dialog';

export enum MessageDialogPreset {
  LOGOUT = 'logout',
  DELETE_CONFIRM = 'delete_confirm',
  UNSAVED_CHANGES = 'unsaved_changes',
}

export const MESSAGE_DIALOG_PRESETS: Record<MessageDialogPreset, MessageDialogData> = {
  [MessageDialogPreset.LOGOUT]: {
    message: 'Are you sure you want to sign out?<br>' + 'You can always login back in at any time.',
    confirmButtonText: 'Sign Out',
    cancelButtonText: 'Cancel',
  },
  [MessageDialogPreset.DELETE_CONFIRM]: {
    message: 'Are you sure you want to delete this item?<br>This action cannot be undone.',
    confirmButtonText: 'Delete',
    cancelButtonText: 'Cancel',
  },
  [MessageDialogPreset.UNSAVED_CHANGES]: {
    message: 'You have unsaved changes.<br>Do you want to leave without saving?',
    confirmButtonText: 'Leave',
    cancelButtonText: 'Stay',
  },
};
